import { Component, OnInit, OnDestroy } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { ExportCertificateModalService } from 'src/app/services/export-certificate-modal/export-certificate-modal.service';
import { ExportCertificateService } from 'src/app/services/export-certificate/export-certificate.service';
import { GeneralService } from 'src/app/services/general/general.service';

declare var bootstrap: any;

@Component({
  selector: 'app-view-export-certificate',
  templateUrl: './view-export-certificate.component.html',
  styleUrls: ['./view-export-certificate.component.scss']
})
export class ViewExportCertificateComponent extends DestructorComponent implements OnInit, OnDestroy {

  certificate: any = null;
  isLoading: boolean = false;
  isExporting: boolean = false;
  pdfUrl = '';

  constructor(
    private _exportCertificateModalService: ExportCertificateModalService,
    private _exportCertificateService: ExportCertificateService,
    private _generalService: GeneralService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupModalListener();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_view_export_certificate');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        const selectedCertificate = this._exportCertificateModalService.getSelectedCertificate();
        if (selectedCertificate) {
          this.loadCertificateDetails(selectedCertificate._id || selectedCertificate.id);
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.certificate = null;
        this._exportCertificateModalService.clearSelectedCertificate();
      });
    }
  }

  private loadCertificateDetails(certificateId: string): void {
    this.isLoading = true;
    this.subscriptions.push(
      this._exportCertificateService.GetDataById(certificateId).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.status && response.data) {
            this.certificate = response.data;
          }
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error('Error loading certificate details:', error);
        }
      })
    );
  }

  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_view_export_certificate');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  getCurrentDate(): string {
    return new Date().toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  getCurrentDay(): string {
    return new Date().getDate().toString().padStart(2, '0');
  }

  getCurrentMonth(): string {
    return (new Date().getMonth() + 1).toString().padStart(2, '0');
  }

  getCurrentYear(): string {
    return new Date().getFullYear().toString();
  }

  getVehicleDisplayName(vehicle: any): string {
    if (!vehicle) return '';
    return `${vehicle.year || ''} ${vehicle.comapny_name || ''} ${vehicle.name || ''}`.trim();
  }

  exportCertificate(certificate: any): void {
    this.isExporting = true;

    let data = {
      certificate_id: certificate._id || certificate.id,
      type : 'vehicle-export-certificate'
    }

    this.subscriptions.push(
      this._generalService.generatePDF(data).subscribe({
        next: (res: any) => {
          this.isExporting = false;
          console.log('res-->', res);
          this.pdfUrl = res.data.url;
          // Handle successful PDF generation here
          // You might want to download the PDF or show a success message
        },
        error: (error: any) => {
          this.isExporting = false;
          console.error('Error generating PDF:', error);
          // Handle error here - show error message to user
        }
      })
    );
  }

  openPdf(): void {
    window.open(this.pdfUrl, '_blank');
  }
}
